export default "__VITE_ASSET__Bz1IJ7Iz__"